import { createSelector } from 'reselect';

const selectTierPrices = (state: any) => state.tierPrices;


export const selectTierPriceCurrentItem = createSelector([selectTierPrices], (tierPrices) => tierPrices.current);

export const selectTierPricesListItems = createSelector([selectTierPrices], (tierPrices) => tierPrices.list);

export const selectTierPriceItemById = (itemId: any) =>
    createSelector(selectTierPricesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTierPriceQueryItems = createSelector([selectTierPrices], (tierPrices) => tierPrices.query);

export const selectTierPriceCreatedItem = createSelector([selectTierPrices], (tierPrices) => tierPrices.create);

export const selectTierPriceUpdatedItem = createSelector([selectTierPrices], (tierPrices) => tierPrices.update);

export const selectTierPriceReadItem = createSelector([selectTierPrices], (tierPrices) => tierPrices.read);

export const selectTierPriceDeletedItem = createSelector([selectTierPrices], (tierPrices) => tierPrices.delete);

export const selectTierPriceSearchedItems = createSelector([selectTierPrices], (tierPrices) => tierPrices.search);

export const selectTierPriceItemsCount = createSelector([selectTierPrices], (tierPrices) => tierPrices.count);

export const selectTierPriceItemsFilter = createSelector([selectTierPrices], (tierPrices) => tierPrices.filter);